import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { environment } from '../../environments/environment';
import { Router } from '@angular/router';
import { IntegrationCredentials } from '../shared/models/general/integration-credentials';

@Injectable({
  providedIn: 'root',
})
export class IntegrationCredentialService {
  env = environment;
  apiUrl = this.env.apiurl + 'platform/integration-credentials/';

  constructor(
    private http: HttpClient,
    public router: Router
  ) {}

  public GetAll(): Observable<IntegrationCredentials[]> {
    return this.http.get<IntegrationCredentials[]>(`${this.apiUrl}`);
  }

  public UpdateCredential(
    credential: IntegrationCredentials
  ): Observable<IntegrationCredentials> {
    return this.http
      .put<IntegrationCredentials>(this.apiUrl, credential, {
        observe: 'response',
      })
      .pipe(map((response) => response.body));
  }
}
